module.exports = __webpack_public_path__ + "bancar-landing/media/1kat.mp4";